module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_VIRTUAL_2_B-1b81ecd7b4da9ec999987f2554b845df.gif";